import styled from 'styled-components'
import {FavouriteIcon, MTText, RegularButton} from '../../atoms'
import React from "react";

// La cabecera (primer hijo, con el paginador en carga) se queda visible; el resto se atenúa
export const Container = styled.div`
  &.is-loading > *:not(:first-child) {
    opacity: 0.5;
    pointer-events: none;
    transition: opacity 0.2s ease;
  }
`

// Título de página de Velora (20/600) en lugar de 40 px en negrita
export const Title = styled.p`
  margin: 24px 0 8px;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
`

export const InfoList = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
`
export const InfoItem = styled.div`
  display: flex;
`
export const InfoItemUnderlined = styled.div`
  display: flex;
  justify-content: space-between;
`
export const Label = styled(props => <MTText {...props} />)``
export const Text = styled(props => <MTText {...props} />)`
  text-align: left;
`
export const CommentsTable = styled.div`
  && {
    padding: 30px 0;
  }
  & .MuiTableSortLabel-root,
  th {
    color: ${({ theme }) => theme.primary};
    &:hover {
      color: ${({ theme }) => theme.primary};
    }
    &:focus {
      color: ${({ theme }) => theme.primary};
    }
    &.MuiTableSortLabel-active {
      color: ${({ theme }) => theme.primary};
    }
    & .MuiTableSortLabel-icon {
      color: ${({ theme }) => theme.primary} !important;
    }
  }
`

export const ProcessTitle = styled.span``

export const Toolbar = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 20px;
`

export const ActionButton = styled(props => <RegularButton {...props}/>)`
  margin: 10px;
`
// Nombre de la persona con la escala del resto de fichas: 18/600 (antes 36 px en negrita)
export const UserName = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
`

export const ProcessIsFavourite = styled(props => <FavouriteIcon {...props}/>)`
  font-size: 20px !important;
`
